Ext.define('SA.VectorMapExportNorthArrow', {
    singleton: true,

    svg: [
        '<svg viewBox="0 0 270 500">',
            '<path d="M93.092,500.002V395.56h14.3l54.924,82.066V395.56h13.114v104.442h-14.027l-54.951-82.035v82.035H93.092z" />',
            '<polygon fill="#fff" points="134.745,1.144 7.66,367.358 134.745,254.928" />',
            '<polygon points="134.356,1.144 261.442,367.358 134.356,254.928" />',
            '<path d="M0,378.793L131.45,0l6.783,1.144v255.355L0,378.793z M131.257,21.834L15.32,355.925l115.937-102.568V21.834z" />',
            '<path d="M269.101,378.793L130.869,256.499V1.144L137.652,0L269.101,378.793z M137.845,253.356l115.937,102.568L137.845,21.834 V253.356z" />',
        '</svg>'
    ],

    getSvg({height, width}) {
        var svg = SA.Html.parse(this.svg);

        SA.Svg.setAttr(svg, 'width', width);
        SA.Svg.setAttr(svg, 'height', height);

        return svg;
    }
});